import { render, staticRenderFns } from "./FormatEditView.vue?vue&type=template&id=665921b9&scoped=true&"
import script from "./FormatEditView.vue?vue&type=script&lang=ts&"
export * from "./FormatEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665921b9",
  null
  
)

export default component.exports